import { render, staticRenderFns } from "./MatchCustomerWidget.vue?vue&type=template&id=e181274a&scoped=true&"
import script from "./MatchCustomerWidget.vue?vue&type=script&lang=ts&"
export * from "./MatchCustomerWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e181274a",
  null
  
)

export default component.exports